import React from 'react';
import AUIInputCheckboxField from '@ancert/aui-input-checkbox-field';
import AUIInputTextAreaField from '@ancert/aui-input-textarea-field';
import { useFormularDenuncia } from '../../context/formularDenuncia.context';
import ArchivosAdjuntos from './ArchivosAdjuntos';
import PersonasImplicadas from './PersonasImplicadas';
import InfoHeader from '../InfoHeader';
import InfoContainer from '../InfoContainer';
import DummyLink from '../dummyLink';
import { getConditions, getPrivacy } from '../../services/config.service';
import { POLICY_NAMES } from '../../config';
import { downloadPdf } from '../../utils/downloadUtils';

const PersonasArchivos = () => {
  const {
    archivosAdjuntos,
    audioAdjuntado,
    control,
    formState,
    personasImplicadas,
    nFormFieldFilled,
    nFormField,
    watch,
  } = useFormularDenuncia();
  const headerInfo = [
    { icon: 'audio', description: `Audios: ${audioAdjuntado ? '1' : '0'}` },
    { icon: 'chatOutline', description: `Formulario: ${nFormFieldFilled()}/${nFormField()}` },
    { icon: 'userOutline', description: `Denunciante: ${watch('isAnonimo') ? 'Anónimo' : watch('document')}` },
    { icon: 'attach', description: `Archivos adjuntos: ${archivosAdjuntos.length}` },
    { icon: 'docUsers', description: `Personas implicadas: ${personasImplicadas.length}` },
  ];

  const isReunion = watch('reunion')?.length > 0;

  const downloadPrivacidad = async () => {
    const { status, data: response } = await getPrivacy();
    if (status === 200) {
      await downloadPdf({ blob: response, fileName: POLICY_NAMES.PRIVACY });
    }
  };

  const downloadInformacion = async () => {
    const { status, data: response } = await getConditions();
    if (status === 200) {
      await downloadPdf({ blob: response, fileName: POLICY_NAMES.INFORMATION });
    }
  };

  return (
    <div className="c-sii-personas-archivos u-mt-24">
      <h2>Personas relacionadas y Archivos adjuntos</h2>
      <InfoHeader items={headerInfo} />
      <ArchivosAdjuntos />
      <PersonasImplicadas />
      <div className="o-sii-checkbox-container u-mt-32">
        <AUIInputCheckboxField
          classNameField="c-sii-field--no-feedback"
          id="reunion"
          name="reunion"
          checkboxArray={[{ label: 'Quiero solicitar una reunión.', value: 1 }]}
          controlRef={control}
          errors={formState.errors}
        />
        {isReunion && (
          <AUIInputTextAreaField
            name="departamento"
            label="¿Con quien le gustaría reunirse?"
            controlRef={control}
            errors={formState.errors}
          />
        )}
      </div>

      <InfoContainer />
      <AUIInputCheckboxField
        required
        id="acceptPolicy"
        name="acceptPolicy"
        checkboxArray={[
          {
            label: (
              <span>
                He leído y acepto la{' '}
                <DummyLink
                  insideText
                  label="Política del sistema interno de información"
                  onClick={downloadInformacion}
                />{' '}
                y la <DummyLink insideText label="Política de privacidad" onClick={downloadPrivacidad} />
                <i className="aui-form-field__label-req">*</i>
              </span>
            ),
            value: 1,
          },
        ]}
        controlRef={control}
        errors={formState.errors}
      />
    </div>
  );
};
PersonasArchivos.propTypes = {};
PersonasArchivos.defaultProps = {};

export default PersonasArchivos;
